import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';


@Component({
    selector: 'app-hometwo-banner',
    templateUrl: './hometwo-banner.component.html',
    styleUrls: ['./hometwo-banner.component.scss'],
})
export class HometwoBannerComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    mainBannerItem = [
    {
        title: 'Taste the ',
        title2:'Tradition of India',
        tagline: 'Union Fire Production',
        subtitle: 'Safety You Can Trust',
        paragraph: 'We provide reliable fire safety solutions designed to protect industries, buildings, and people from fire risks.',
        buttonText: 'EXPLORE SOLUTIONS',
        buttonLink: '/services',
        image: 'assets/img/slider/s1.jpg',
        overlayColor: 'rgba(120, 20, 20, 0.7)',
        s1:'assets/img/spices/s1.png',
        s2:'assets/img/spices/s2.png',
        s3:'assets/img/spices/s3.png',
    },
    {
        title: 'Authentic Flavours from ',
        title2:' Every Indian Kitchen',
        tagline: 'Built for High-Risk Environments',
        subtitle: 'Engineered for Protection',
        paragraph: 'Our fire systems are designed for factories, warehouses, and production units to ensure maximum safety.',
        buttonText: 'VIEW SYSTEMS',
        buttonLink: '/services',
        image: 'assets/img/slider/s2.jpg',
        overlayColor: 'rgba(90, 30, 30, 0.7)',
        s1:'assets/img/spices/s4.png',
        s2:'assets/img/spices/s5.png',
        s3:'assets/img/spices/s6.png',
    },
    {
        title: 'Where Recipes ',
        title2:'Tell Stories',
        tagline: 'Strong. Safe. Reliable.',
        subtitle: 'Protection That Lasts',
        paragraph: 'We deliver high-quality fire-resistant materials and solutions built to withstand extreme conditions.',
        buttonText: 'SEE PRODUCTS',
        buttonLink: '/products',
        image: 'assets/img/slider/km_slide3.jpg',
        overlayColor: 'rgba(80, 25, 25, 0.7)',
        s1:'assets/img/spices/s1.png',
        s2:'assets/img/spices/s2.png',
        s3:'assets/img/spices/s3.png',
    },
    {
        title: 'Serving India on ',
        title2:'Every Plate',
        tagline: 'Prepared for Every Situation',
        subtitle: 'Fast Response Technology',
        paragraph: 'Our advanced systems detect and control fire hazards quickly, helping reduce damage and risk.',
        buttonText: 'LEARN MORE',
        buttonLink: '/services',
        image: 'assets/img/slider/s3.jpg',
        overlayColor: 'rgba(100, 20, 20, 0.7)',
        s1:'assets/img/spices/s4.png',
        s2:'assets/img/spices/s5.png',
        s3:'assets/img/spices/s6.png',
    },
    {
        title: 'From Our Kitchen to ',
        title2:'Your Heart',
        tagline: 'Quality You Can Depend On',
        subtitle: 'Tested & Approved',
        paragraph: 'All our solutions meet strict safety standards, ensuring reliable performance in critical situations.',
        buttonText: 'VIEW CERTIFICATIONS',
        buttonLink: '/about',
        image: 'assets/img/slider/s5.jpg',
        overlayColor: 'rgba(70, 20, 20, 0.7)',
        s1:'assets/img/spices/s1.png',
        s2:'assets/img/spices/s2.png',
        s3:'assets/img/spices/s3.png',
    },
     
];
    

    homeSlidesOptions: OwlOptions = {
        loop: true,
        nav: true,
        margin: 0,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoHeight: true,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        autoplayHoverPause: true,
        navText: [
            "<i class='bx bx-chevron-left'></i>",
            "<i class='bx bx-chevron-right'></i>"
        ],
        responsive: {
            0: { items: 1 },
            576: { items: 1 },
            768: { items: 1 },
            992: { items: 1 },
            1200: { items: 1 }
        }
    }

}
